// eslint-disable-next-line
import React, { FC } from 'react';
import { Theme, makeStyles } from '@material-ui/core/styles';

import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import { useHistory } from 'react-router-dom';
import { useWizard } from './context';

const useStyles = makeStyles((theme: Theme) => ({
  root: { marginTop: 'auto' },
}));

type Props = {
  disableSubmit?: boolean;
  onClickPreviousStep?: () => any;
  onClickNextStep?: () => any;
  insideForm?: boolean;
  submitButtonText?: string;
};

const Controls: FC<Props> = ({
  disableSubmit,
  onClickPreviousStep,
  onClickNextStep,
  submitButtonText,
  insideForm = false,
}) => {
  const history = useHistory();
  const [
    { showPreviousButton, isLastStep, historyCancel },
    wizardDispatch,
  ] = useWizard();
  const classes = useStyles();

  const handleNextButtonClick = () => {
    if (onClickNextStep) {
      onClickNextStep();
    } else {
      wizardDispatch.next();
    }
  };

  return (
    <Grid container className={classes.root} spacing={3}>
      <Grid item xs>
        {showPreviousButton && (
          <Button
            data-testid="wizard-prev-btn"
            type="button"
            size="medium"
            color="primary"
            onClick={() => {
              if (onClickPreviousStep) {
                onClickPreviousStep();
              } else {
                wizardDispatch.prev();
              }
            }}
          >
            ANTERIOR
          </Button>
        )}
      </Grid>

      <Grid container item justify="space-between" xs={3}>
        <Button
          type="button"
          color="primary"
          size="medium"
          onClick={() => {
            history.push(historyCancel);
          }}
          data-testid="wizard-cancel-btn"
        >
          CANCELAR
        </Button>

        <Button
          type={insideForm ? 'submit' : 'button'}
          onClick={handleNextButtonClick}
          size="medium"
          variant="contained"
          color="primary"
          disabled={disableSubmit}
          data-testid="wizard-next-btn"
        >
          {isLastStep
            ? submitButtonText || 'FINALIZAR'
            : submitButtonText || 'SIGUIENTE'}
        </Button>
      </Grid>
    </Grid>
  );
};

export default Controls;
